import { useMemo } from 'react';
import type { ChatMessage, SessionArtwork, SessionParticipant, StageDisplayMode } from '@modelcast/types';
import { RoomContext, type RoomContextValue } from '../room/RoomProvider';
import { SidebarPanel } from '../room/SidebarPanel';

const roomCode = 'E2E-SIDEBAR';
const participantId = 'artist-e2e';
const startedAt = '2026-06-02T11:00:00.000Z';

const chatMessages: ChatMessage[] = [
  {
    id: 'chat-1',
    roomId: 'room-e2e',
    participantId: 'artist-other',
    participantName: 'Maya Artist',
    profileId: null,
    content: 'The charcoal study is looking good.',
    createdAt: '2026-06-02T11:02:00.000Z',
  },
  {
    id: 'chat-2',
    roomId: 'room-e2e',
    participantId,
    participantName: 'You',
    profileId: null,
    content: 'I will upload mine in the break.',
    createdAt: '2026-06-02T11:03:00.000Z',
  },
];

function createRoomContextValue(): RoomContextValue {
  const stageDisplayMode: StageDisplayMode = 'active-speaker';

  return {
    roomCode,
    socket: null,
    sessionState: null,
    isHost: true,
    hostParticipantIds: [participantId],
    originalHostId: participantId,
    modelParticipantId: 'model-e2e',
    modelProfileId: 'profile-model',
    modelParticipantIds: ['model-e2e'],
    modelCameraLabels: { 'model-e2e': 'A' },
    participants: [
      {
        participantId,
        displayName: 'E2E Host',
        role: 'host',
        joinedAt: startedAt,
        isConnected: true,
        profileId: 'profile-host',
      } satisfies SessionParticipant,
    ],
    bannedParticipants: [],
    remoteMutes: {},
    recording: null,
    browserAudio: null,
    browserAudioSettings: {
      autoMuteArtistsDuringPoses: true,
      lowerMusicDuringBreaks: true,
    },
    poseTimer: null,
    schedule: [],
    isHighResStreaming: false,
    pinnedArtworkId: null,
    galleryArtworkFavorites: {},
    stagePinnedParticipantId: null,
    stageDisplayMode,
    activeSpeakerTuning: {
      minAudioLevel: 0.08,
      switchDwellMs: 650,
      minDisplayMs: 2400,
      switchMargin: 0.04,
      currentLevelHoldMs: 900,
    },
    viewerOrientationStats: {
      portrait: 0,
      landscape: 0,
      total: 0,
      portraitPercent: 0,
      landscapePercent: 0,
    },
    startedAt,
    sessionName: 'Sidebar E2E Session',
    chatMessages,
    chatTypingUsers: new Map(),
    toggleHost: () => undefined,
    banParticipant: () => undefined,
    unbanParticipant: () => undefined,
    setModelProfile: () => undefined,
    updateSchedule: () => undefined,
    updateBrowserAudioSettings: () => undefined,
    pinArtwork: () => undefined,
    clearPinnedArtwork: () => undefined,
    pinStageParticipant: () => undefined,
    clearStagePinnedParticipant: () => undefined,
    setStageDisplayMode: () => undefined,
    updateActiveSpeakerTuning: () => undefined,
    resetActiveSpeakerTuning: () => undefined,
  };
}

export function SidebarPanelTestPage() {
  const roomContextValue = useMemo(createRoomContextValue, []);

  return (
    <RoomContext.Provider value={roomContextValue}>
      <main className="min-h-screen bg-bg p-6">
        <div className="mx-auto h-[720px] max-w-md overflow-hidden rounded-xl border border-line bg-panel shadow-xl">
          <SidebarPanel
            roomCode={roomCode}
            participantId={participantId}
            artistProfileId="profile-host"
            artistName="E2E Host"
            onUpload={() => undefined}
            onPinArtwork={(_artwork: SessionArtwork) => undefined}
            canPinArtwork
            initialTab="chat"
          />
        </div>
      </main>
    </RoomContext.Provider>
  );
}
